
import {
	Component,
	Vue
} from "vue-property-decorator";
import CollapseItem from '@/components/collapse.vue';
import PageFooter from '@/components/page-footer.vue';
import Dialog from '@/components/dialog.vue';
import previewImg from '@/components/previewImg.vue';
import {
	getOssToken,
	bankFinanceSettlelist
} from '@/api/user'
import {
	creareSupplier,
	setSupplier,
	supplierInfo,
	providercheckSuccess,
	providercheckReject
} from '@/api/supplier'
import UploadImg from '@/components/upload-img.vue';
import AddressSelect from '@/components/address-select.vue';
import {
	providerReturnAddressSelectItem,
} from '@/api/logistics';

import {
	imgHost
} from '@/utils/config';
import {
	handleClipboard
} from '@/utils/clipboard'

@Component({
	name: 'supplier-detail',
	components: {
		CollapseItem,
		PageFooter,
		UploadImg,
		AddressSelect,
		'slz-dialog': Dialog,
		previewImg
	}
})
export default class SupplierDetail extends Vue {
	private type = this.$route.query.type;
	private id = +this.$route.query.id || 0;
	private imgUrl: string = imgHost;
	private chooseTab = 0;
	private paperType = 0;
	private disabled = false
	private token = {}; // 上传token
	private papers: any = [{
		label: '居民身份证',
		value: 1
	}]
	private personRole: any = [{
		label: '法人代表',
		value: 1
	}]
	private formData: any = {
		Id: 0,
		Account: '', // 账号,
		Password: '', //密码,
		Province: '', //省,
		City: '', //市,
		Area: '', //区,
		Address: '', //详细地址,
		DeliveryTime: '', //发货时效--多少天内发货,
		RealName: '', //真实姓名,
		IdCardNo: '', //身份证号码,
		CompanyName: '', //公司名称,
		LicenseImgId: '', //公司证件号,
		LicenseImgUrl: '', //营业执照,
		CardIdFrontImgUrl: '', //身份证正面,
		CardIdBackImgUrl: '', //身份证反面,
		ProviderReturnAddressDtoList: [], //退货地址
		ContractType: 0,
		AccountName: '',
		CollectAccount: '',
		OpenAccountBankName: '',
		OpenAccountInfoImgUrl: '',
		OpenAccountLicenceImgUrl: '',
		EnterpriseName: '',
		EnterpriseTaxNo: '',
		EnterpriseAddress: '',
		EnterprisePhone: '',
		EnterpriseBankAccount: '',
		EnterpriseOpenAccountBank: '',
		OpenAccountBankId: '',
		EnterpriseBankName: '',
		OpenAccountBankCode: '',
		EnterpriseOpenBankAndAccount: '',
	}
	private formRule: any = {
		'Account': '请输入注册账号 ',
		'Password': '密码不能为空',
		'CompanyName': '请输入公司名称', // 公司名称
		// 'LicenseImgId': '请填写公司证件号', // 公司证件
		// 'Province': '地址填写不完整',
		// 'City': '地址填写不完整',
		// 'Area': '地址填写不完整',
		// 'Address': '地址填写不完整',
		'RealName': '请输入法人姓名', // 真实姓名
		// 'IdCardNo': '请填写身份证', // 身份证
		'CardIdFrontImgUrl': '请上传法人身份证正面照', // 身份证正面
		'CardIdBackImgUrl': '请上传法人身份证反面照', // 身份证反面
		'LicenseImgUrl': '请上传营业执照', // 营业执照
	}
	private refundList: any = []
	private currentNoFillIn: any = []
	private rejectedShow = false
	private ProviderRejectReason = ''
	private currentUrl = ''
	private showPreview = false
	private imgHost = imgHost
	private bklist: any = []

	private mounted() {
		// this.getToken();
		this.getbanklist()
		if (this.id) {
			this.getSupplierInfo();
			this.refundAddress()
		}
	}


	private changebank(e) {
		let msg = this.bklist.find(v => v.Id == e)
		if (msg && msg.Id) {
			// console.log(msg)
			this.formData.OpenAccountBankCode = msg.BankCode
		}
	}
	private async getbanklist() {
		try {
			let res = await bankFinanceSettlelist({})
			if (res.IsSuccess) {
				this.bklist = res.Result
			}
		} finally {
			//
		}
	}
	private copyMsg(e) {
		let text = this.formData.AccountName + '的开票信息：' + '\n'
		text += '企业名称：' + this.formData.EnterpriseName + '\n'
		text += '企业税号：' + this.formData.EnterpriseTaxNo + '\n'
		text += '企业地址：' + this.formData.EnterpriseAddress + '\n'
		text += '企业电话：' + this.formData.EnterprisePhone + '\n'
		// text += '企业银行账户：' + this.formData.EnterpriseBankAccount + '\n'
		// text += '企业开户银行：' + (this.formData.EnterpriseBankName||'') + `（行号：${(this.formData.OpenAccountBankCode||'')}）` + '\n'
		text += '开户行及账户号：' + this.formData.EnterpriseOpenBankAndAccount + '\n'
		handleClipboard(text, e)
	}
	private uploadSuc2(file, name, key) {
		// console.log(file,name,i,key)
		this.formData[key] = file[0]
	}
	private lookLarge(url) {
		this.currentUrl = this.imgHost + this.formData[url]
		// console.log(this.currentUrl)
		this.showPreview = true
	}

	private cancel() {
		this.rejectedShow = false
		this.ProviderRejectReason = ''
	}
	// 返回上一页
	private toBack() {
		this.$router.go(-1)
	}

	// 获取token
	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.token = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			console.log('getOssToken ===>', e)
		}
	}

	// 上传成功
	private uploadSuc(list: any, type?: string) {
		this.formData[type] = list[0]
		this.formData[type + 'List'] = list
		// console.log(this.formData, type)
	}

	// 获取省市信息
	private getAddress(list: string[]) {
		this.formData.Province = list[0];
		this.formData.City = list[1];
		this.formData.Area = list[2];
	}

	// 数据是否为空
	private isEmpty() {
		for (let key in this.formData) {
			if (this.type == 'edit' && key === 'password') continue;
			if (this.formRule[key] && !this.formData[key]) {
				this.$message({
					type: 'warning',
					message: this.formRule[key]
				})
				return true
			}
		}
		return false;
	}

	// 获取供应商信息
	private async getSupplierInfo() {
		try {
			const res: any = await supplierInfo({
				Id: +this.id
			})
			this.formData = res.Result;
			this.formData.LicenseImgUrlList = [this.formData.LicenseImgUrl]
			this.formData.CardIdFrontImgUrlList = [this.formData.CardIdFrontImgUrl]
			this.formData.CardIdBackImgUrlList = [this.formData.CardIdBackImgUrl]
			this.disabled = res.Result.ProviderCheckState == 2
			for (let key in this.formData) {
				// console.log(key)
				if (!this.formData[key]) {
					this.currentNoFillIn.push(key)
				}
			}

			this.formData.ContractType = this.formData.ContractType || null
			this.formData.OpenAccountBankId = this.formData.OpenAccountBankId || null

			// console.log(this.currentNoFillIn)
		} catch (err) {
			console.error('supplierInfo ===>', err)
		}
	}

	// 提交信息
	private submit(type: number) {
		if (this.isEmpty()) return false;

		if (type == 1) {
			this.doCreate()
		} else if (type == 2) {
			this.topass()
		} else if (type == 3) {
			this.rejectedShow = true
			// this.torejected()
		}
	}
	private async topass() {
		try {
			let data = JSON.parse(JSON.stringify(this.formData))
			let res = await providercheckSuccess({
				ProviderId: this.id,
				...data
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.toBack()
			}
		} finally {
			//
		}
	}
	private async torejected() {
		if (!this.ProviderRejectReason) {
			this.$message.error('请输入驳回原因')
			return
		}
		try {
			let res = await providercheckReject({
				ProviderId: this.id,
				ProviderRejectReason: this.ProviderRejectReason
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.toBack()
			}
		} finally {
			//
		}
	}
	// 创建
	private async doCreate() {
		// this.formData.delivery_time = +this.formData.delivery_time
		try {
			await creareSupplier(this.formData);
			this.$message({
				type: 'success',
				message: '创建成功'
			})
			this.toBack()
		} catch (err) {
			// this.$message({
			// 	type: 'error',
			// 	message: '创建失败'
			// })
		}
	}


	// 获取退款地址
	private async refundAddress() {
		try {
			const res: any = await providerReturnAddressSelectItem({
				ProviderId: +this.id
			});
			this.refundList = res.Result;
		} catch (e) {
			console.log(e)
		}
	}
}
